<template>
    <v-row justify="center">
        <v-dialog v-model="isVisible" persistent max-width="600px">
            <v-card>
                <v-card-title>
                    <span class="headline">{{$vuetify.lang.t('$vuetify.remarks.remarksDialogTitle')}}</span>
                </v-card-title>
                <v-card-text>
                    <v-container>
                        <v-row>
                            <v-textarea
                                    v-model="remarks"
                                    counter
                                    :maxlength="maxLength"
                                    rows="4"
                                    ref="inputRef"
                                    :label="$vuetify.lang.t('$vuetify.remarks.remarksDialogPlaceholder')"
                            ></v-textarea>
                        </v-row>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click.prevent="close(false)">{{$vuetify.lang.t('$vuetify.global.cancel')}}</v-btn>
                    <v-btn color="blue darken-1" text @click.prevent="close(true)" :disabled="isFilled">{{$vuetify.lang.t('$vuetify.global.save')}}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-row>
</template>

<script>
    export default {
        name: "RemarksInputComponent",
        props : {
            isVisible : {
                type : Boolean,
                default : false
            },
            maxLength : {
              type : Number,
              default : 255
            },
            minLength : {
                type : Number,
                default : 4
            },
            initial_remarks :{
                type : String,
                default : ''
            }
        },
        data : () => {
            return {
                remarks : ''
            }
        },
        methods : {
            close(didConfirm){
                let data = {
                    userConfirmed : didConfirm,
                    remarks : this.remarks
                }
                this.$emit('closed' , data);

            }
        },
        watch : {
            initial_remarks: {
                handler(after){
                    this.remarks = after;
                }
            },
            /*isVisible(value){
                console.log('shown : '+value)
            }*/
        },
        computed:{
            isFilled: function () {
                if(this.remarks.length >= this.minLength){
                    return false;
                }else{
                    return true
                }
            }
        }
    }
</script>

<style scoped>

</style>